import {   
  TUTOR_SIGN_UP, 
  TUTOR_PROFILE_UPDATE,   
} from '../Type';

export const tutorSignUp = (data) => {
  return {
    type: TUTOR_SIGN_UP,
    data: data
  }
}

export const tutorProfileUpdate = (data) => {
  return {
    type: TUTOR_PROFILE_UPDATE,
    data: data
  }
}